/* eslint-disable @next/next/no-img-element -- copying as is from packages/ui for now */
// TODO: This will be moved to torque-ui once I figured out how to make images work in consuming app from torque
export function AutocorpLogo() {
  return (
    <div className="text-center">
      <img width={150} height={80} src="/assets/images/powered-by-autocorp-logo.svg" alt="autocorp-logo" />
    </div>
  );
}
